import './index.scss';

window.addEventListener('DOMContentLoaded', () => {
    const calculateur = document.querySelector('.calculateur-economie');
    const lang = document.querySelector('html').getAttribute('lang');
  

    if(calculateur){
        let forms = calculateur.querySelectorAll('form.step');
        const button = calculateur.querySelector('div.footer button');
        const nav = calculateur.querySelectorAll('div.header ul li');
        const result = calculateur.querySelector('div.results');
        const back = result.querySelector('#back');

        const contact = calculateur.querySelector('#result-contact');
        const submit = contact.querySelector('button[type="submit"]');
        const success = contact.querySelector('.success');
        const error = contact.querySelector('.error');

        const spanUnitEau = calculateur.querySelectorAll('.unit_eau');
        const spanUnitMonnaie = calculateur.querySelectorAll('.unit_monnaie');
        const spanUnitPoids = calculateur.querySelectorAll('.unit_poids');
        const spanUnitEnergie = calculateur.querySelectorAll('.unit_energie');


        const select_unit = calculateur.querySelector('select#unite_eau');
        const select_monnaie = calculateur.querySelector('select#unite_monnaie')
        let unit_eau = 'm³';
        let unit_monnaie = '€';
        let unit_poids = 'kg';
        let unit_energie = 'MWh';

        setTimeout(() => {
            if(window.innerWidth < 767){
                calculateur.style.maxHeight = calculateur.querySelector('.calculateur').offsetHeight + 'px';
            }    
        }, 500)
            

        select_monnaie.addEventListener('change', (e) => {
            unit_monnaie = e.target.value === 'euro' ? '€' : '$'; 
            unit_energie = e.target.value === 'euro' ? 'MWh' : 'kWh';

            spanUnitMonnaie.forEach(element => {
                element.textContent = unit_monnaie;
            });

            spanUnitEnergie.forEach(element => {
                element.textContent = unit_energie;
            });
        })

        select_unit.addEventListener('change', (e) => {
            unit_eau = e.target.value === 'metre_cube' ? 'm³' : 'gal'; 
            unit_poids = e.target.value === 'metre_cube' ? 'kg' : 'lbs'
            spanUnitEau.forEach(element => {
                element.textContent = unit_eau;
            });

            spanUnitPoids.forEach(element => {
                element.textContent = unit_poids;
            });
        })

        if(forms.length > 0) {
            forms[0].style.maxHeight = forms[0].scrollHeight + 'px';
        }

        const debounceHandleInput = debounce(handleInput, 250);
        
        for(let form of forms){
            form.addEventListener('input', debounceHandleInput);
        }

        function addSpacesToNumber(number) {
            let numStr = number.toString();
            let parts = numStr.split('.');
        
            // Process integer part
            let integerPart = parts[0];
            let result = '';
        
            // Iterate over the string from right to left
            for (let i = integerPart.length - 1, j = 0; i >= 0; i--, j++) {
                // Insert space after every third digit except for the rightmost digits
                if (j > 0 && j % 3 === 0) {
                    result = ' ' + result;
                }
                result = integerPart[i] + result;
            }
        
            // Add decimal part if it exists
            if (parts.length > 1) {
                result += '.' + parts[1];
            }
        
            return result;
        }
        
        
        function handleInput(){
            if(isFilled(this)){
                let index = [...forms].indexOf(this);
                if(index + 1 < forms.length){
                    if(nav.length > 0){
                        nav[index + 1].classList.add('active');
                    }
                    revealForm(forms[index + 1]);
                } else {
                    if(button){
                        button.classList.add('active')
                    }
                }
            }
        }

        if(back){
            back.addEventListener('click', () => {
                calculateur.classList.remove('loaded');
                if(window.innerWidth < 767){
                    calculateur.style.maxHeight = calculateur.querySelector('.calculateur').offsetHeight + 'px';
                }
            })
        }

        if(button){
            button.addEventListener('click', calculate);
        }
        
        function isFilled(form){
            let formData = new FormData(form);
            for (let value of formData.values()){
                if(!value || value === null || value.length === 0 || value === ""){
                    return false;
                }
            }
            return true;
        }

        function revealForm(element){
            element.style.maxHeight = element.scrollHeight + 'px';
            calculateur.style.maxHeight = calculateur.querySelector('.calculateur').scrollHeight + 'px';
        }

        function debounce(func, wait, immediate, context) {
            var result;
            var timeout = null;
            return function() {
                var ctx = context || this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) result = func.apply(ctx, args);
                };
                var callNow = immediate && !timeout;
                // Tant que la fonction est appelée, on reset le timeout.
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) result = func.apply(ctx, args);
                return result;
            };
        }

        function calculate(){
            calculateur.classList.add('loading');

            const EURO_TO_DOLLAR = 1.090;
            const LBS_TO_KG = 0.45359237;
            const kWh_TO_MWh = 1000;
            /**
             * DONNES UTILISATEUR
             */

            let puissance_installe = unit_poids === 'lbs' ? parseFloat(calculateur.querySelector('input[name="puissance_installe"]').value) * LBS_TO_KG : parseFloat(calculateur.querySelector('input[name="puissance_installe"]').value), 
            cout_energie = unit_monnaie === '€' ? parseFloat(calculateur.querySelector('input[name="cout_energie"]').value) : (parseFloat(calculateur.querySelector('input[name="cout_energie"]').value) / EURO_TO_DOLLAR) , 
            cout_eau = unit_monnaie === '€' ? parseFloat(calculateur.querySelector('input[name="cout_eau"]').value) : parseFloat(calculateur.querySelector('input[name="cout_eau"]').value) / EURO_TO_DOLLAR, 
            cout_carbone_emis = unit_monnaie === '€' ? parseFloat(calculateur.querySelector('input[name="cout_carbone_emis"]').value) : parseFloat(calculateur.querySelector('input[name="cout_carbone_emis"]').value) / EURO_TO_DOLLAR, 
            temps_fonctionnement = parseFloat(calculateur.querySelector('input[name="temps_fonctionnement"]').value), 
            taux_condensat = parseFloat(calculateur.querySelector('input[name="taux_condensat"]').value) / 100,
            conductivite_eau = parseFloat(calculateur.querySelector('input[name="conductivite_eau"]').value),
            conductivite_chaudiere = parseFloat(calculateur.querySelector('input[name="conductivite_chaudiere"]').value);


            /**
             * DONNEES PAR DEFAUT
             */
            const taux_charge = 1,
            conductivite_condensats = 25,
            PCI = 9.6,
            emission_ges = 0.207,
            enthalpie_eau_bouillante = 781.6;

            /**
             * CALCULS TRAITEMENT TRADITIONEL
             */
            let puissance_installe_t = puissance_installe / 0.453592;
            let tonnage_vapeur = (puissance_installe*temps_fonctionnement*(taux_charge))/1000;
            let tonnage_condensats = taux_condensat*tonnage_vapeur
            let conductive_eau_alimentaire = ((conductivite_condensats*taux_condensat)+(1-taux_condensat)*conductivite_eau)
            let taux_concentration_eau_alimentaire = (conductivite_chaudiere / conductive_eau_alimentaire);
            let taux_concentration_eau_appoint = conductivite_chaudiere/conductivite_eau;
            let taux_purge = 1 / taux_concentration_eau_alimentaire;
            let taux_evaporation = (1 - taux_purge);
            let volume_annuel_alimentaire = tonnage_vapeur/taux_evaporation;
            let volume_annuel_apoint = volume_annuel_alimentaire - tonnage_condensats;
            let volume_annuel_vapeur_perdu = tonnage_vapeur - tonnage_condensats;
            let volume_annuel_purge = taux_purge * volume_annuel_alimentaire;

            let bool_1 = taux_purge + taux_evaporation === 1;
            let bool_2 =  volume_annuel_apoint === volume_annuel_vapeur_perdu + volume_annuel_purge;

            let valeur_energetique_kj_perdu = (volume_annuel_purge*enthalpie_eau_bouillante)*1000;
            let valeur_energetique_kwh_perdu = valeur_energetique_kj_perdu/3600;
            let equivalent_gn = valeur_energetique_kwh_perdu/PCI;
            let emission_ges_t = emission_ges*valeur_energetique_kwh_perdu;

            // let data_traitement_traditionel = {
            //     puissance_installe_t,
            //     tonnage_vapeur,
            //     tonnage_condensats,
            //     conductive_eau_alimentaire,
            //     taux_concentration_eau_alimentaire,
            //     taux_concentration_eau_appoint,
            //     taux_purge,
            //     taux_evaporation,
            //     volume_annuel_alimentaire,
            //     volume_annuel_apoint,
            //     volume_annuel_vapeur_perdu,
            //     volume_annuel_purge,
            //     bool_1,
            //     bool_2,
            //     valeur_energetique_kj_perdu,
            //     valeur_energetique_kwh_perdu,
            //     equivalent_gn,
            //     emission_ges_t
            // }

            // console.log("=============== TRAITEMENT TRADITIONEL ===============");
            // console.table(data_traitement_traditionel);
            // console.log("======================================================");

            /**
             * CALCULS TRAITEMENT FILMOGENE
             */

            let conductivite_chaudiere_f = conductivite_chaudiere / 0.88;
            let taux_concentration_eau_alimentaire_f = conductivite_chaudiere_f / conductive_eau_alimentaire;
            let taux_concentration_eau_appoint_f = conductivite_chaudiere_f / conductivite_eau;
            let taux_purge_f = 1 / taux_concentration_eau_alimentaire_f;
            let taux_evaporation_f = 1 - taux_purge_f;
            let volume_annuel_alimentaire_f = tonnage_vapeur / taux_evaporation_f;
            let volume_annuel_apoint_f = volume_annuel_alimentaire_f - tonnage_condensats;
            let volume_annuel_purge_f = volume_annuel_alimentaire_f * taux_purge_f;
            let bool_3 = taux_purge_f + taux_evaporation_f === 1;
            let bool_4 = volume_annuel_vapeur_perdu + volume_annuel_purge_f === volume_annuel_apoint_f;
            let valeur_energetique_kj_perdu_f = (volume_annuel_purge_f * enthalpie_eau_bouillante)*1000;
            let valeur_energetique_kwh_perdu_f = valeur_energetique_kj_perdu_f / 3600;
            let equivalent_gn_f = valeur_energetique_kwh_perdu_f / PCI;
            let emission_ges_f = emission_ges * valeur_energetique_kwh_perdu_f;

            // let data_traitement_filmogene = {
            //     conductivite_chaudiere_f,
            //     taux_concentration_eau_alimentaire_f,
            //     taux_concentration_eau_appoint_f,
            //     taux_purge_f,
            //     taux_evaporation_f,
            //     volume_annuel_alimentaire_f,
            //     volume_annuel_apoint_f,
            //     volume_annuel_purge_f,
            //     bool_3,
            //     bool_4,
            //     valeur_energetique_kj_perdu_f,
            //     valeur_energetique_kwh_perdu_f,
            //     equivalent_gn_f,
            //     emission_ges_f,
            // }

            // console.log("=============== TRAITEMENT FILMOGENE ===============");
            // console.table(data_traitement_filmogene);
            // console.log("====================================================");


            /**
             * RESULTATS
             */

            let economie_energie = valeur_energetique_kwh_perdu - valeur_energetique_kwh_perdu_f;
            let economie_energe_gn = equivalent_gn - equivalent_gn_f;
            let valorisation = (economie_energie * cout_energie) / 1000;
            let gain_eau = unit_eau === 'm³' ? volume_annuel_purge - volume_annuel_purge_f : (volume_annuel_purge - volume_annuel_purge_f) * 264.172176857989 ;
            let valorisation_gain_eau = gain_eau * cout_eau;

            let reduction_emissions_ges_kg = emission_ges_t - emission_ges_f;
            let reduction_emissions_ges_t = reduction_emissions_ges_kg/1000;
            let valorisation_reduction_emissions = (cout_carbone_emis * reduction_emissions_ges_kg)/1000;
            let bruh = ((((((puissance_installe*temps_fonctionnement*(taux_charge))/1000)/(1-(1/( conductivite_chaudiere/(((conductivite_condensats*taux_condensat)+(1-taux_condensat)*conductivite_eau))))))*(1/( conductivite_chaudiere/(((conductivite_condensats*taux_condensat)+(1-taux_condensat)*conductivite_eau)))))*enthalpie_eau_bouillante*1000)/3600)-((((( (puissance_installe*temps_fonctionnement*(taux_charge))/1000)/( 1-(1/ (((conductivite_condensats*taux_condensat)+(1-taux_condensat)*( conductivite_eau*1)))/( taux_condensat*((puissance_installe*temps_fonctionnement*(taux_charge))/1000)))))*(1/((((conductivite_condensats*taux_condensat)+(1-taux_condensat)*( conductivite_eau*1)))/( taux_condensat*((puissance_installe*temps_fonctionnement*(taux_charge))/1000)))))*enthalpie_eau_bouillante*1000)/3600)

            // let data_resultats = {
            //     economie_energie,
            //     economie_energe_gn,
            //     valorisation,
            //     gain_eau,
            //     valorisation_gain_eau,
            //     reduction_emissions_ges_kg,
            //     reduction_emissions_ges_t,
            //     valorisation_reduction_emissions,
            //     bruh
            // }

            // console.log("=============== RESULTATS ===============");
            // console.table(data_resultats);
            // console.log("====================================================");

            let label_poids = '';

            if(unit_poids === 'kg'){
                label_poids = lang === 'fr-FR' ? ' tonnes de CO₂' :
                lang === 'en-US' ? ' tons of CO₂' :
                lang === 'es-ES' ? ' toneladas de CO₂' : '';
            } else {
                label_poids = lang === 'fr-FR' ? ' livres de CO₂' :
                lang === 'en-US' ? ' lbs of CO₂' :
                lang === 'es-ES' ? ' libras de CO₂' : '';
            }

            let label_gaz = '';
            if(unit_poids === 'kg'){
                label_gaz = lang === 'fr-FR' ? ' m³ de gaz' :
                lang === 'en-US' ? ' m³ gas' :
                lang === 'es-ES' ? ' m³ de gaz' : '';
            } else {
                label_gaz = lang === 'fr-FR' ? ' livres de gaz' :
                lang === 'en-US' ? ' pounds of gas' :
                lang === 'es-ES' ? ' libras de gaz' : '';
            }
            

            const label_purge = lang === 'fr-FR' ? ` ${unit_eau} par purge` :
            lang === 'en-US' ? ` ${unit_eau} as blowndowns` :
            lang === 'es-ES' ? ` ${unit_eau} por purga` : '';

            const label_tonnes = label_poids;
            
            const unit = unit_monnaie
            calculateur.querySelector('span#economie_energie').textContent = addSpacesToNumber(Math.round(economie_energie)) + label_gaz;
            calculateur.querySelector('span#gain_eau').textContent = Math.round(gain_eau) + label_purge;
            calculateur.querySelector('span#reduction_emissions_ges_t').textContent = Math.round((reduction_emissions_ges_t/ LBS_TO_KG) * 100) / 100 + label_tonnes ;

            let total_euro = Math.round(((Math.round(valorisation * 100) / 100) + (Math.round(valorisation_gain_eau * 100) / 100) + (Math.round(valorisation_reduction_emissions * 100) / 100)) * 100) / 100;
            let total = unit_eau === '€' ? total_euro.toFixed(2) : (total_euro * EURO_TO_DOLLAR).toFixed(2); 
            calculateur.querySelector('#total').textContent = addSpacesToNumber(total) + " " + unit

            calculateur.classList.remove('loading');
            calculateur.classList.add('loaded');

            if(window.innerWidth < 767){
                calculateur.style.maxHeight = calculateur.querySelector('.results').offsetHeight + 'px';
                // console.log(calculateur.querySelector('.results').offsetHeight);
                calculateur.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            }
        }

        const handleSubmit = (data) => {
            return new Promise((resolve, reject) => {
                let headers = new Headers()
                data.append('action', 'send_calculateur');
                
                let init = {
                    method: 'POST', 
                    body: data,
                    headers: headers,
                }
    
                fetch(ajaxurl, init)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err)
                }) 
            })
        }

        if(contact){
            contact.addEventListener('submit', (e) => {
                e.preventDefault();
                submit.classList.add('loading');

                const data = new FormData(e.target);
                handleSubmit(data)
                .then(res => res.json()
                    .then(res => {
                        submit.classList.remove('loading');
                        success.classList.add('active');
                        error.classList.remove('active');
                        console.log(res)
                    })
                )
                .catch(err => {
                    submit.classList.remove('loading');
                    success.classList.remove('active');
                    error.classList.add('active');
                    console.log(err)
                })
            })
        }
    }
})